import api from '@/lib/api'

const state = () => ({
  allInvoices: [],
  allPayments: [],

  currentHistoryItem: {
    lead_id: -1,
    amount_cents: 0,
    category: '',
    description: '',
    history_time: 0,
  },

  currentInvoice: {
    invoice_id: -1,

    invoice_date: new Date(),

    sales: [],
    pro: {
      address: { }
    },
  },

  currentPayment: {
    payment_id: -1,

    collected_cents: 0,
    deposited_cents: 0,
    description: '',
    fees_reserved_cents: 0,
    payment_date: new Date(),
    status: '',

    payment_method: {
      brand: '',
      last4: '',
    },
  },

  history: [],

  refillPolicy: {
    deposit_cents: 5000,
    floor_cents: 600,
    primary_payment_method: '',
    secondary_payment_method: '',
  },

  newCardSecret: {
    client_secret: '',
    payment_id: -1,
  },

})

const getters = {
  allInvoices: state => state.allInvoices,
  allPayments: state => state.allPayments,
  currentHistoryItem: state => state.currentHistoryItem,
  currentInvoice: state => state.currentInvoice,
  currentPayment: state => state.currentPayment,
  history: state => state.history,
  refillPolicy: state => state.refillPolicy,
  newCardSecret: state => state.newCardSecret,
}

const actions = { 
  async loadAllInvoices({ commit }) {
    const result = await api.get('/invoices')
    if (result.ok) {
      commit('SET_ALL_INVOICES', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadAllPayments({ commit }) {
    const result = await api.get('/payments')
    if (result.ok) {
      commit('SET_ALL_PAYMENTS', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadCurrentInvoice({ commit }, { invoice_id }) {
    const result = await api.get(`/invoices/${ invoice_id }`)
    if (result.ok) {
      commit('SET_CURRENT_INVOICE', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadCurrentHistoryItem({ commit }, { lead_id }) {
    const result = await api.get(`/history/item/${ lead_id }`)
    if (result.ok) {
      commit('SET_CURRENT_HISTORY_ITEM', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadCurrentPayment({ commit }, { payment_id }) {
    const result = await api.get(`/payments/${ payment_id }`)
    if (result.ok) {
      commit('SET_CURRENT_PAYMENT', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadHistory({ commit }, { disputable = null, extra_months = null } = {}) {
    let params = new URLSearchParams()
    if (disputable) params.append( 'disputable', disputable )
    if (extra_months) params.append( 'extra_months', extra_months )

    const result = await api.get('/history' + (params.toString() ? '?' + params : ''))
    if (result.ok) {
      commit('SET_HISTORY', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadRefillPolicy({ commit }) {
    const result = await api.get('/refill_policy')
    if (result.ok) {
      commit('SET_REFILL_POLICY', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadNewCardSecret({ commit }) {
    const result = await api.put('/payments/new_card_secret')
    if (result.ok) {
      commit('SET_NEW_CARD_SECRET', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async pay({ commit }, { payment_method, amount_cents }) {
    const result = await api.put('/payments/pay', { payment_method, amount_cents })
    if (result.ok) {
      commit('auth/SET_ME', await result.json(), { root: true })
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async reactivate({ commit }, payload) {
    const result = await api.put('/payments/reactivate', payload)
    if (result.ok) {
      commit('auth/SET_ME', await result.json(), { root: true })
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async toggleCardSecret({ commit }, { refill_enabled, payment_id, payment_intent }) {
    const result = await api.put('/payments/toggle_card_secret', { refill_enabled, payment_id, payment_intent })
    if (result.ok) {
      commit('SET_NEW_CARD_SECRET', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async updateRefillPolicy({ commit }, refill_policy) {
    const result = await api.put('/refill_policy', { refill_policy })
    if (result.ok) {
      commit('SET_REFILL_POLICY', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  } 
}

const mutations = { 
  SET_ALL_INVOICES: (state, invoices) => state.allInvoices = invoices,
  SET_ALL_PAYMENTS: (state, payments) => state.allPayments = payments,
  SET_CURRENT_HISTORY_ITEM: (state, item) => state.currentHistoryItem = item,
  SET_CURRENT_INVOICE: (state, invoice) => state.currentInvoice = invoice,
  SET_CURRENT_PAYMENT: (state, payment) => state.currentPayment = payment,
  SET_HISTORY: (state, history) => state.history = history,
  SET_NEW_CARD_SECRET: (state, paymentIntent) => state.newCardSecret = paymentIntent,
  SET_REFILL_POLICY: (state, refillPolicy) => state.refillPolicy = refillPolicy,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}